import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import useRestrictedReportsHook from "../hooks/RestrictedReportsHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";

const CurrentCourseSchedule = ({ schoolId, linkColor }) => {
  const { data, loading } = useRestrictedReportsHook(schoolId);

  const current_course_schedule =
    data.length > 0 ? data[0].current_course_schedule : "";

  if (loading) {
    return <div>Loading...</div>;
  }
  const subject = "Current Course Schedule";

  return (
    <Card>
      <CardHeader
        title="Current Course Schedule"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {current_course_schedule && (
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <Button
              variant="contained"
              component="a"
              href={current_course_schedule}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#AC1A2F",
                color: "white",
                minWidth: "auto",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#8B0000",
                },
              }}
            >
              View Report
            </Button>
            <SchoolNotificationButton subject={subject} schoolId={schoolId} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CurrentCourseSchedule;
